export default "__VITE_ASSET__DE_5FTfK__"